import type { FC } from "react";

export type ProposalInfoTarget = "hr" | "matter";

export type ProposalInfoInputProps = {
  value: string;
  onChange: (value: string) => void;
  target: ProposalInfoTarget;
  disabled?: boolean;
};

const PLACEHOLDER: Record<ProposalInfoTarget, string> = {
  hr: "提案したい人材情報を入力（例: 氏名 佐藤, スキル Java/Spring, 希望単価 60万円, 稼働開始 即日）",
  matter:
    "提案したい案件情報を入力（例: 案件名, 必要スキル Python, 報酬 100万円, 勤務地 東京, 期間 6ヶ月）",
};

const LABEL: Record<ProposalInfoTarget, string> = {
  hr: "提案したい人材情報",
  matter: "提案したい案件情報",
};

/**
 * 返信メール作成時の提案対象テキストエリア
 *
 * case に応じて人材情報 / 案件情報のプレースホルダを切替。
 * AI 生成時、自社マージン加味済みの単価・商流で本文を作らせるための情報源となる。
 *
 * @param {ProposalInfoInputProps} props
 * @return {JSX.Element}
 */
export const ProposalInfoInput: FC<ProposalInfoInputProps> = ({
  value,
  onChange,
  target,
  disabled,
}) => {
  return (
    <div>
      <label className="label py-0">
        <span className="label-text text-xs">
          {LABEL[target]}
          <span className="text-gray-400 ml-1">（AI生成で使用, 任意）</span>
        </span>
      </label>
      <textarea
        className="textarea textarea-bordered w-full text-sm"
        rows={5}
        maxLength={5000}
        placeholder={PLACEHOLDER[target]}
        value={value}
        disabled={disabled}
        onChange={e => onChange(e.target.value)}
      />
    </div>
  );
};
